const STORAGE_KEY = 'legalEntityRegistration';

const defaultState = {
  maxStep: 1,
  step2: {
    timerStart: null,
    challengeId: null,
    completed: false,
  },
  step3: {
    timerStart: null,
    challengeId: null,
    completed: false,
  },
  step6: {
    verificationLink: null,
  },
};

const getState = () => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : { ...defaultState };
  } catch {
    return { ...defaultState };
  }
};

const setState = (newState) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
  } catch {
  }
};

export const LegalEntityRegistrationStorage = {
  getMaxStep: () => {
    const state = getState();
    return state.maxStep || 1;
  },

  setMaxStep: (step) => {
    const state = getState();
    setState({ ...state, maxStep: step });
  },

  getStep2TimerStart: () => {
    const state = getState();
    const timerStart = state.step2?.timerStart;
    if (timerStart) {
      const elapsed = Date.now() - timerStart;
      if (elapsed < 300000) {
        return timerStart;
      }
    }
    return null;
  },

  setStep2TimerStart: (timestamp) => {
    const state = getState();
    setState({
      ...state,
      step2: { ...state.step2, timerStart: timestamp },
    });
  },

  getStep2ChallengeId: () => {
    const state = getState();
    return state.step2?.challengeId || null;
  },

  setStep2ChallengeId: (id) => {
    const state = getState();
    setState({
      ...state,
      step2: { ...state.step2, challengeId: id },
    });
  },

  getStep2Completed: () => {
    const state = getState();
    return state.step2?.completed || false;
  },

  setStep2Completed: (completed) => {
    const state = getState();
    setState({
      ...state,
      step2: { ...state.step2, completed },
    });
  },

  clearStep2: () => {
    const state = getState();
    setState({
      ...state,
      step2: { timerStart: null, challengeId: null, completed: false },
    });
  },

  getStep3TimerStart: () => {
    const state = getState();
    const timerStart = state.step3?.timerStart;
    if (timerStart) {
      const elapsed = Date.now() - timerStart;
      if (elapsed < 300000) {
        return timerStart;
      }
    }
    return null;
  },

  setStep3TimerStart: (timestamp) => {
    const state = getState();
    setState({
      ...state,
      step3: { ...state.step3, timerStart: timestamp },
    });
  },

  getStep3ChallengeId: () => {
    const state = getState();
    return state.step3?.challengeId || null;
  },

  setStep3ChallengeId: (id) => {
    const state = getState();
    setState({
      ...state,
      step3: { ...state.step3, challengeId: id },
    });
  },

  getStep3Completed: () => {
    const state = getState();
    return state.step3?.completed || false;
  },

  setStep3Completed: (completed) => {
    const state = getState();
    setState({
      ...state,
      step3: { ...state.step3, completed },
    });
  },

  clearStep3: () => {
    const state = getState();
    setState({
      ...state,
      step3: { timerStart: null, challengeId: null, completed: false },
    });
  },

  getStep6VerificationLink: () => {
    const state = getState();
    return state.step6?.verificationLink || null;
  },

  setStep6VerificationLink: (link) => {
    const state = getState();
    setState({
      ...state,
      step6: { ...state.step6, verificationLink: link },
    });
  },

  clearStep6: () => {
    const state = getState();
    setState({
      ...state,
      step6: { verificationLink: null },
    });
  },

  clearAll: () => {
    sessionStorage.removeItem(STORAGE_KEY);
  },
};
